import { render, staticRenderFns } from "./DelegationForm.vue?vue&type=template&id=10f22447&scoped=true"
import script from "./DelegationForm.vue?vue&type=script&lang=js"
export * from "./DelegationForm.vue?vue&type=script&lang=js"
import style0 from "./DelegationForm.vue?vue&type=style&index=0&id=10f22447&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f22447",
  null
  
)

export default component.exports